export enum ReceiptRouteName {
    Index = 'finance.receipts.index',
}

export default {
    path: 'receipts',
    name: ReceiptRouteName.Index,
    component: () => import('@/views/finance/receipts/Index.vue'),
    meta: {
        label: 'Receipts',
        auth: true,
        permission: 'manage-customer-receipts',
        icon: 'fal fa-file-invoice-dollar fa-fw',
        location: 'sidebar',
        parent: 'finance',
    },
}
